"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var calendar_1 = require("./src/calendar/calendar");
var common_1 = require("@angular/common");
var CalendarModule = (function () {
    function CalendarModule() {
    }
    CalendarModule.forRoot = function () {
        return {
            ngModule: CalendarModule,
            providers: []
        };
    };
    return CalendarModule;
}());
CalendarModule.decorators = [
    { type: core_1.NgModule, args: [{
                imports: [
                    common_1.CommonModule,
                ],
                declarations: [
                    calendar_1.CalendarComponent
                ],
                exports: [
                    calendar_1.CalendarComponent
                ]
            },] },
];
/** @nocollapse */
CalendarModule.ctorParameters = function () { return []; };
exports.CalendarModule = CalendarModule;
//# sourceMappingURL=angular2-fullcalendar.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ap-angular2-fullcalendar/angular2-fullcalendar.js
// module id = 788
// module chunks = 3